import { toast } from '@/hooks/use-toast';
import { PartnerProgramService } from '@/services/partner-program.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

export function useAttachPartner(productId: string) {
  const { t } = useTranslation(['affiliates', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (partnerEmail: string) =>
      PartnerProgramService.attachPartner(productId, partnerEmail),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['partner-program-partners', productId],
      });
      toast({
        variant: 'success',
        description: t('affiliates:partner_added'),
      });
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      toast({
        variant: 'error',
        description:
          error?.response?.data?.message || t('common:data_submission_error'),
      });
    },
  });
}

export function useDeactivatePartner(productId: string) {
  const { t } = useTranslation(['affiliates', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (partnerUuid: string) =>
      PartnerProgramService.deactivatePartner(productId, partnerUuid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['partner-program-partners', productId],
      });
      toast({
        variant: 'success',
        description: t('affiliates:partner_removed'),
      });
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      toast({
        variant: 'error',
        description:
          error?.response?.data?.message || t('common:data_submission_error'),
      });
    },
  });
}
